import * as React from 'react';
import './index.scss';

interface PropType {
    baoAccountIsDisplayAssurance: boolean
}

export default function Index ( props: PropType ) {
    const { baoAccountIsDisplayAssurance } = props;
    if ( !baoAccountIsDisplayAssurance ) return null;
    return (
        <div id="product-ta" />
    )
}
